import SpriteAnim from 'sprite-anim'
import debounce from 'debounce'

class Animation {
  constructor ({ element, frames, frameRate, delay, interval }) {
    this.element = element
    this.width = this.element.offsetWidth
    this.height = this.element.offsetHeight
    this.frames = frames
    this.frameRate = frameRate
    this.delay = delay
    this.interval = interval
  }

  createPlayer () {
    const _renderer = new SpriteAnim.DOMRenderer(this.element)
    const _parser = new SpriteAnim.SimpleParser({
      width: (this.width * this.frames),
      height: this.height
    }, {
      width: this.width,
      height: this.height
    })
    this.player = new SpriteAnim(_parser, _renderer, { frameRate: this.frameRate })
  }

  updateParser () {
    const _newWidth = this.element.offsetWidth
    const _newHeight = this.element.offsetHeight

    if (_newWidth !== this.width || _newHeight !== this.height) {
      this.width = _newWidth
      this.height = _newHeight

      this.player.pause()
      this.player.parser = new SpriteAnim.SimpleParser({
        width: (this.width * this.frames),
        height: this.height
      }, {
        width: this.width,
        height: this.height
      })
      this.player.renderFrame()
      this.player.play()
    }
  }
}

class Sprites {
  constructor () {
    this.sprites = []
    this.activeClass = 'sprite--active'
    this.timers = []

    window.addEventListener('resize', debounce(() => this.resizeAnimations(), 200))
  }

  animate (page) {
    if (this.sprites.length === 0 && window.matchMedia('(min-width: 1024px)').matches) {
      const _parent = document.getElementById(page)
      const _sprites = _parent.querySelectorAll('.sprite')

      for (const item of _sprites) {
        const _sprite = {
          element: item,
          frames: item.getAttribute('data-frames'),
          frameRate: item.getAttribute('data-framerate'),
          delay: item.getAttribute('data-delay'),
          interval: item.getAttribute('data-interval'),
          isActive: true
        }
        this.sprites.push(_sprite)
      }
    }

    this.initAnimations()
  }

  initAnimations () {
    // set up animations
    for (const sprite of this.sprites) {
      if (sprite.animation === undefined) {
        sprite.animation = new Animation(sprite)
        sprite.animation.createPlayer()
      }
      sprite.isActive = true
      this.startAnimation(sprite)
    }
  }

  startAnimation (sprite) {
    const _loop = () => {
      if (sprite.isActive) {
        sprite.animation.player.gotoAndPlay(0)
      }
    }

    // add active class
    sprite.element.classList.add(this.activeClass)

    // play animation after a delay
    setTimeout(() => sprite.animation.player.play(), sprite.delay)

    // loop animation once it's complete
    sprite.animation.player.on('complete', () => {
      setTimeout(_loop, sprite.interval)
    })
  }

  resizeAnimations () {
    if (this.sprites && this.sprites.length > 0) {
      for (const sprite of this.sprites) {
        sprite.animation.updateParser()
      }
    }
  }

  disable () {
    for (const sprite of this.sprites) {
      sprite.element.classList.remove(this.activeClass)
      sprite.animation.player.dispose()
      sprite.isActive = false
    }
  }
}

export { Sprites }



// WEBPACK FOOTER //
// ./src/classes/Sprites.js